import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { RoleModel } from "../../models/RoleModel";
import RoleService from "../../services/RoleService";
import RoleSlice from "../slices/RoleSlice";
import { RootState } from "../store";

export const RoleActions = RoleSlice.actions;
export const fetchRoles = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(RoleActions.setIsRolesFetching(true));
    const response: RoleModel[] = await RoleService.getAllRoles();
    dispatch(RoleActions.setRoles(response));
    dispatch(RoleActions.setIsRolesFetching(false));
  };
};
export const fetchParticularRole = (
  Role_id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch, getState) => {
    const response: RoleModel = await RoleService.getParticularRole(Role_id);
    dispatch(RoleActions.setParticularRole(response));
  };
};
